import React from 'react';
import RedirectButton from '../button/RedirectButton';
import { cn } from '../../../lib/utils';

interface ButtonRedirectAction {
  text: string;
  url: string;
  openInNewTab?: boolean;
  disabled?: boolean;
}

interface RedirectActionsBarProps {
  primaryAction: ButtonRedirectAction;
  secondaryAction: ButtonRedirectAction;
  className?: string;
}

const RedirectActionsBar: React.FC<RedirectActionsBarProps> = ({
  primaryAction,
  secondaryAction,
  className
}) => {
  const cardStyles: React.CSSProperties = {
    display: 'flex',
    width: '100%', // Figma has 1031px, but component can be placed anywhere,
    // hence 100% ensures this bar inherits the entire width of the parent container
    height: '52px',
    padding: '12px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '16px',
    borderRadius: '14px',
    background: '#FFF',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)',
  };

  return (
    <div style={cardStyles} className={cn(className)}>
      <RedirectButton
        text={primaryAction.text}
        url={primaryAction.url}
        openInNewTab={primaryAction.openInNewTab}
        disabled={primaryAction.disabled}
      />
      <RedirectButton
        text={secondaryAction.text}
        url={secondaryAction.url}
        openInNewTab={secondaryAction.openInNewTab}
        disabled={secondaryAction.disabled}
      />
    </div>
  );
};

export default RedirectActionsBar;